<div class="auth-page">
  <div class="auth-bg" aria-hidden="true"></div>

  <div class="auth-card" role="main" aria-label="Register">
    <div class="brand">
      <img
        class="brand-logo"
        src="https://cdn.auth0.com/quantum-assets/dist/latest/logos/auth0/auth0-lockup-en.svg"
        alt="Auth0"
        loading="lazy"
      />
      <div class="brand-badge">Sign up</div>
    </div>

    <h1 class="title">Create your account</h1>


    @if (auth.isLoading$ | async) {
      <div class="loading">
        <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
        <div class="loading-text">Preparing secure sign-up…</div>
      </div>
    } @else {
      <div class="actions">
        <button mat-flat-button color="primary" class="primary" (click)="signup()">
          <mat-icon>person_add</mat-icon>
          Create account
        </button>

        <a class="secondary-link" href="#" (click)="$event.preventDefault(); login()">
          Already have an account? Sign in
        </a>
      </div>
    }
  </div>
</div>

